import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function UrgencyBar() {
  // Start with 14 minutes and 55 seconds (895 seconds)
  const [timeLeft, setTimeLeft] = useState(895);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `00:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 right-0 z-50 bg-urgency text-white py-2 px-4 shadow-md" data-id="element-203">
      <div className="max-w-4xl mx-auto flex items-center justify-center text-center text-sm sm:text-base font-medium" data-id="element-204">
        <span className="font-bold tracking-wider" data-id="element-205">
          ⚠️ Precio de lanzamiento: $6.36 — Disponible solo mientras dure esta
          oferta especial
        </span>
      </div>
    </div>;
}